module.exports = __webpack_public_path__ + "static/media/014 I GUERRA M_Torre del bordello.ee072686.svg";